// frontend/src/components/Provider/ProviderListMobile.tsx
// CLEANED VERSION - No selection/bulk operations, mobile-first design

import React from 'react';
import { Provider } from '@/lib/api/providerService';
import ProviderCard from './ProviderCard';

interface ProviderListMobileProps {
  providers: Provider[];
  onView: (provider: Provider) => void;
  onEdit: (provider: Provider) => void;
  onDelete: (id: number, businessName: string) => void;
  onVerify: (id: number) => void;
  onToggleStatus: (id: number) => void;
}

const ProviderListMobile: React.FC<ProviderListMobileProps> = ({
  providers,
  onView,
  onEdit,
  onDelete,
  onVerify,
  onToggleStatus
}) => {
  return (
    <div className="bg-white shadow overflow-hidden sm:rounded-lg">
      {/* Provider cards - no selection functionality */}
      <div className="divide-y divide-gray-200">
        {providers.map((provider) => (
          <ProviderCard
            key={provider.provider_id}
            provider={provider}
            onView={() => onView(provider)}
            onEdit={() => onEdit(provider)}
            onDelete={() => onDelete(provider.provider_id, provider.business_name)}
            onVerify={() => onVerify(provider.provider_id)}
            onToggleStatus={() => onToggleStatus(provider.provider_id)}
          />
        ))}
      </div>
    </div>
  );
};

export default ProviderListMobile;